import Loadable from '@react-loadable/revised';

const LoadableEtcFileDetail = Loadable({
    loader: () => import('./EtcFileDetail'),
    loading: () => null
});

export default LoadableEtcFileDetail;
